module.exports = __webpack_public_path__ + "static/media/Anuvadi.24c0ee0b.png";